module.exports = __webpack_public_path__ + "static/media/sign-in-background.d46464fa.jpg";